import { readJsonPref, writeJsonPref } from '@utils/localJsonPref';
import { PLAN_GROUPINGS, type PlanGroupBy } from './workPlanModel';

/**
 * Per-site memory of the Work Plan's grouping, so leaving and returning to
 * Activities restores it (like the tracker's `trackerPrefs`). Browser-local,
 * keyed by siteId; validated on read so a stale or hand-edited value falls
 * back to the default. The date window is the page's (`useDateWindow`),
 * remembered there.
 */
const KEY_PREFIX = 'dorca.workplan.prefs.';

export interface IWorkPlanPrefs {
  groupBy: PlanGroupBy;
}

export const DEFAULT_WORK_PLAN_PREFS: IWorkPlanPrefs = { groupBy: 'profession' };

export function readWorkPlanPrefs(siteId: string): IWorkPlanPrefs {
  const raw: Partial<Record<keyof IWorkPlanPrefs, unknown>> = Object(readJsonPref(KEY_PREFIX + siteId));
  return {
    groupBy: PLAN_GROUPINGS.find((g) => g === raw.groupBy) ?? DEFAULT_WORK_PLAN_PREFS.groupBy,
  };
}

export function writeWorkPlanPrefs(siteId: string, prefs: IWorkPlanPrefs): void {
  writeJsonPref(KEY_PREFIX + siteId, prefs);
}
